/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespNullSearchResultsHeader_itemSearch$ref = any;
type SbSharedFollowSearchProvider_itemSearch$ref = any;
export type SbRespNullSearchResults_itemSearch$ref = any;
export type SbRespNullSearchResults_itemSearch = {
    readonly " $fragmentRefs": SbSharedFollowSearchProvider_itemSearch$ref & SbRespNullSearchResultsHeader_itemSearch$ref;
    readonly " $refType": SbRespNullSearchResults_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResultsHeader_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '1054d58d961db4f88386302fe068326c';
export default node;
